export default __webpack_public_path__ + "static/thebottomline18-37e090bd9a8a8ce15cf1fa4b86d844c5.jpg";